/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import AdvSalesChart from './advSalesChart';

const ShowAdvSales = ({ dir, data, viewReportButton, title }) => {
    const thisMonthData = {};
    data.forEach((item) => {   
        const monthDayYear = moment(item.date).format('MM-DD-YYYY')          
        if (item.date && thisMonthData[monthDayYear]) {
            thisMonthData[monthDayYear].push(item)
        } else {
            thisMonthData[monthDayYear] = [item]
        }
                   
    })
 //   const max = currentMonthDayCount > prevMonthDayCount ? currentMonthDayCount : prevMonthDayCount;
    const reduceCallback = (acc, item) => acc + Number(item.advSales)
    const reduceCallbackForTotalSales = (acc, item) => acc + Number(item.totalSales)
    const reduceCallbackForTotalSpend = (acc, item) => acc + Number(item.spend)
    const dataToPlot = []
    
    Object.keys((thisMonthData)).forEach((dayMonthYear) => {
        const totalAdvSales = thisMonthData?.[dayMonthYear].reduce(reduceCallback, 0)
        const totalSales = thisMonthData?.[dayMonthYear].reduce(reduceCallbackForTotalSales, 0)
        const totalSpend = thisMonthData?.[dayMonthYear].reduce(reduceCallbackForTotalSpend, 0)
        const aCOS = ((totalSpend * 100)/totalAdvSales).toFixed(2);
        dataToPlot.push({
            "day": dayMonthYear,            
            'Sales': Number(totalSales),
            'AdvSales': Number(totalAdvSales),
            'Spend': Number(totalSpend),
            'ACOS': Number(aCOS)
        })
    })

    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                <div className="card__title row " style={{ position: 'relative' }} >
                    {title}
                    <div id='dvChartView'>
                    {viewReportButton?.()}</div>
                </div>

                {data?.length ? (
                    <AdvSalesChart
                        dataToPlot={dataToPlot}
                        height={400}
                        showTitle={false}
                        dir={dir}
                    />

                ) : 'No data to display'}
            </Card>
        </Col>

    )
}

ShowAdvSales.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
};

ShowAdvSales.defaultProps = {
    title: 'Adv Sales',
}

export default ShowAdvSales;
